import type { FC } from 'react'
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from 'react-icons/md'

import { Title } from '../CommonStyleComponents'

import { TitleWrap } from './styles'
import type { ConversationHeaderProps } from './types'

const ConversationHeader: FC<ConversationHeaderProps> = ({
  isExpanded,
  isMobile,
  isReadOnly,
  hasMessages,
  isConversationsEnabled,
  onToggle,
}) => {
  if (isMobile && !isReadOnly) {
    return (
      <TitleWrap onClick={onToggle}>
        <Title>Conversation</Title>
        <div>
          {isExpanded ? (
            <MdOutlineKeyboardArrowUp />
          ) : (
            <MdOutlineKeyboardArrowDown />
          )}
        </div>
      </TitleWrap>
    )
  }

  if (hasMessages && isConversationsEnabled) {
    return <Title>Conversation</Title>
  }

  return null
}

export default ConversationHeader
